import { Network } from '@/common/models';
import { DASH } from '@/globals';
import rootState from '@/store/state';

export interface INetworkFrequencyCapAPI {
  network_id: number;
  min_seconds_between_plays: number;
}

export class NetworkFrequencyCap {
  public networkId: number;
  public minSecondsBetweenPlays: number;

  constructor(networkId: number, minSecondsBetweenPlays: number) {
    this.networkId = networkId;
    this.minSecondsBetweenPlays = minSecondsBetweenPlays;
  }

  public static fromApi(apiObject: INetworkFrequencyCapAPI): NetworkFrequencyCap {
    return new NetworkFrequencyCap(apiObject.network_id, apiObject.min_seconds_between_plays);
  }

  public toApi(): INetworkFrequencyCapAPI {
    return {
      network_id: this.networkId,
      min_seconds_between_plays: this.minSecondsBetweenPlays,
    };
  }

  public toString() {
    const { networks } = rootState.orgApp.ReferenceData;
    if (networks == null || networks.length === 0) {
      return DASH;
    }

    const network = networks.find((x: Network) => this.networkId === x.id);
    return `${network.name}: ${this.minSecondsBetweenPlays}s`;
  }

  get network() {
    const { networks } = rootState.orgApp.ReferenceData;
    return networks.find((x: Network) => this.networkId === x.id) || DASH;
  }
}
